import { render, staticRenderFns } from "./Collect.vue?vue&type=template&id=be93453e&scoped=true&"
import script from "./Collect.vue?vue&type=script&lang=ts&"
export * from "./Collect.vue?vue&type=script&lang=ts&"
import style0 from "./Collect.vue?vue&type=style&index=0&id=be93453e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be93453e",
  null
  
)

export default component.exports